// hooks/useAddBranch.ts
import api from "../../../../../features/auth/axiosConfig";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";

export const useAddBranch = (resetForm: () => void, fetchBranches: () => void, closeModal: () => void) => {
  const addBranch = async (formData: any) => {
    if (!formData.Branchname) return notifyError("Please fill in all required fields.");

    const payload = {
      Branch_name: formData.Branchname,
      Branch_Opening_date: formData.branchopeningdate,
      Address: {
        address1: formData.address1,
        street: formData.street,
        selectedCountry: formData.selectedCountry,
        selectedState: formData.selectedState,
        selectedCity: formData.selectedCity,
        Pincode: formData.Pincode,
      },
    };

    try {
      await api.post(`/app/v1/pos/branch`, payload);
      notifySuccess("Branch created successfully");
      resetForm();
      closeModal();
      fetchBranches?.();
    } catch (err: any) {
      notifyError(err.response?.data?.message || "An error occurred.");
    }
  };

  return { addBranch };
};
